import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import Appear from 'components/common/reactAppear';

import {
  Title,
} from 'components/landing/components';

const dumbServices = dumbBem('l-services');

const ContentImageWrp = tx([{ element: 'content-image-wrapper' }, dumbServices])('div');
const ContentBlock = tx([{ element: 'content-block' }, dumbServices])('div');

const SectionBlock = ({ block, sectionModifier }) => {
  return (
    <Appear className="l-services appear-animation">
      <ContentBlock modifier={sectionModifier}>
        <ContentImageWrp>
          <img src={block.icon} alt="" />
        </ContentImageWrp>

        <Title modifier="3 content">{block.title}</Title>

        <ul>
          {block.bullets.map((bullet, bulletId) => (<li key={bulletId}>{bullet}</li>))}
        </ul>
      </ContentBlock>
    </Appear>
  );
};

SectionBlock.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    bullets: PropTypes.array,
  }).isRequired,
  sectionModifier: PropTypes.string.isRequired,
};

export default SectionBlock;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/SectionBlock.jsx